import { createAction, handleActions, combineActions } from 'redux-actions';
// api
import api from '../../utils/api';

const initialState = {
  isLoading: false,
  stripeApiKey: null
};

// const
export const GET_SUBSCRIPTION_PLAN = 'billing/GET_SUBSCRIPTION_PLAN';
export const GET_SUBSCRIPTION = 'billing/GET_SUBSCRIPTION';
export const DELETE_SUBSCRIPTION = 'billing/DELETE_SUBSCRIPTION';

// action creators
export const getSubscriptionPlans = createAction(
  GET_SUBSCRIPTION_PLAN,
  api.billing.getSubscriptionPlans
);
export const getSubscription = createAction(
  GET_SUBSCRIPTION,
  api.billing.getSubscription
);
export const deleteSubscription = createAction(
  DELETE_SUBSCRIPTION,
  api.billing.deleteSubscription
);

// reducer
const reducer = handleActions(
  {
    [combineActions(
      `${GET_SUBSCRIPTION_PLAN}_REQUEST`,
      `${GET_SUBSCRIPTION}_REQUEST`
    )]: state => {
      return {
        ...state,
        isLoading: true
      };
    },
    [`${GET_SUBSCRIPTION_PLAN}_SUCCESS`]: (state, { payload }) => {
      return {
        ...state,
        stripeApiKey: payload.meta.public_stripe_key,
        subscriptionPlans: payload.resources,
        isLoading: false
      };
    },
    [combineActions(
      `${GET_SUBSCRIPTION}_SUCCESS`,
      `${GET_SUBSCRIPTION_PLAN}_ERROR`,
      `${GET_SUBSCRIPTION}_ERROR`
    )]: state => {
      return {
        ...state,
        isLoading: false
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/billing.js